module.exports = __webpack_public_path__ + "img/home_img06.35f64a85.png";